import { createFileRoute } from '@tanstack/react-router';
import { devicesQuery } from '@/features/devices/api';
import { CalibrationPage } from '@/features/devices/pages/CalibrationPage';

/** "Qurilma kolibrovkalash" (586:16515). `?indicator=<id>` = the selected source (physical) indicator. */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/devices/calibration')({
  validateSearch: (search: Record<string, unknown>): { indicator?: string } => ({
    indicator: typeof search.indicator === 'string' && search.indicator ? search.indicator : undefined,
  }),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(devicesQuery(context.tenant.id));
  },
  component: DeviceCalibrationRoute,
});

function DeviceCalibrationRoute() {
  const { tenant } = Route.useRouteContext();
  const { indicator } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CalibrationPage
      tenant={tenant}
      sourceId={indicator}
      onSource={(id) => void navigate({ search: (prev) => ({ ...prev, indicator: id }), replace: true })}
    />
  );
}
